
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b89942838 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b525138742 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b141459382 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a893677009 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a795727742 = pluralGeneratorFn(function(n
) {
  return (n == 1) ? 'one' : 'other';
});
Globalize.b506459019 = messageFormatterFn((function(  ) {
  return function(d) { return "Utazás: nyaralások, olcsó repülőjáratok, repülőjegyek és árak"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1075286819 = messageFormatterFn((function(  ) {
  return function(d) { return "Pontok beváltva"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a152636998 = messageFormatterFn((function(  ) {
  return function(d) { return "Pontok eltávolítva"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b869670646 = messageFormatterFn((function(  ) {
  return function(d) { return "Párbeszédpanel bezárása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2043398067 = messageFormatterFn((function(  ) {
  return function(d) { return "Úti cél"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a55370189 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1950081314 = messageFormatterFn((function(  ) {
  return function(d) { return "Kijelentkezés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a590911691 = messageFormatterFn((function(  ) {
  return function(d) { return "Dátum"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1627875787 = messageFormatterFn((function(  ) {
  return function(d) { return "Utazók"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b770493413 = messageFormatterFn((function(  ) {
  return function(d) { return "Keresés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b825734235 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " – további információ"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1493109442 = messageFormatterFn((function(  ) {
  return function(d) { return "Megnyitja egy új lapon a következőt: " + d["0"] + ", a folytatáshoz térj vissza az eredeti lapra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1278279453 = messageFormatterFn((function(  ) {
  return function(d) { return "Keresési eredmények"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b214957742 = messageFormatterFn((function(  ) {
  return function(d) { return "Adj meg egy úti célt"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a471711188 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz érvényes bejelentkezési dátumot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1406717291 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz dátumokat az utazásodhoz"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1873056401 = messageFormatterFn((function(  ) {
  return function(d) { return "A kijelentkezés dátuma csak a bejelentkezés dátumánál későbbi nap lehet"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a712311001 = messageFormatterFn((function(  ) {
  return function(d) { return "A kijelentkezés dátumának a bejelentkezés dátuma utáni 28 napon belül kell lennie"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1660903395 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz érvényes kijelentkezési dátumot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2122883375 = messageFormatterFn((function(  ) {
  return function(d) { return "Válaszd ki az utazók számát"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1383258022 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg az utazó gyermek életkorát"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1361798358 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg az utazó gyermekek életkorát"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1827082680 = messageFormatterFn((function(  ) {
  return function(d) { return "A szállásfoglalás dátumainak az utazás idejére kell esniük"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1284216787 = messageFormatterFn((function(  ) {
  return function(d) { return "Kiválasztás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2020466689 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " szoba";}, one: function() { return number(d["0"]) + " szoba";}, two: function() { return number(d["0"]) + " szoba";}, few: function() { return number(d["0"]) + " szoba";}, many: function() { return number(d["0"]) + " szoba";}, other: function() { return number(d["0"]) + " szoba";} }) + ", " + plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " utazó";}, one: function() { return number(d["1"]) + " utazó";}, two: function() { return number(d["1"]) + " utazó";}, few: function() { return number(d["1"]) + " utazó";}, many: function() { return number(d["1"]) + " utazó";}, other: function() { return number(d["1"]) + " utazó";} }); }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1737825425 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " utazó";}, one: function() { return number(d["1"]) + " utazó";}, two: function() { return number(d["1"]) + " utazó";}, few: function() { return number(d["1"]) + " utazó";}, many: function() { return number(d["1"]) + " utazó";}, other: function() { return number(d["1"]) + " utazó";} }); }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1847372397 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " utazó";}, one: function() { return number(d["1"]) + " utazó";}, two: function() { return number(d["1"]) + " utazó";}, few: function() { return number(d["1"]) + " utazó";}, many: function() { return number(d["1"]) + " utazó";}, other: function() { return number(d["1"]) + " utazó";} }) + ", házi kedvencek"; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b242417780 = messageFormatterFn((function(  ) {
  return function(d) { return "Utazók"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1168204608 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". szoba hozzáadva. A vendégek adatai az alábbiakban szerkeszthetők."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a726404960 = messageFormatterFn((function(  ) {
  return function(d) { return "Szoba eltávolítva. A(z) " + d["0"] + ". szoba vendégeinek adatai az alábbiakban szerkeszthetők."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1491583676 = messageFormatterFn((function(  ) {
  return function(d) { return "Mégse, az Utazóválasztó bezárása a módosítások mentése nélkül. Vagy szerkeszd a vendég adatait alább."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b940125316 = messageFormatterFn((function(  ) {
  return function(d) { return "Kész"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b650251388 = messageFormatterFn((function(  ) {
  return function(d) { return "Módosítások mentése és az Utazóválasztó bezárása."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b826232088 = messageFormatterFn((function(  ) {
  return function(d) { return "Extra szoba hozzáadása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1171776377 = messageFormatterFn((function(  ) {
  return function(d) { return "Szoba eltávolítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1609350401 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". szoba eltávolítása a(z) " + d["1"] + " közül "; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b77858367 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". gyermek életkora"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a819770279 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". szoba"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1666496518 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". szoba a(z) " + d["1"] + " közül"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b75833672 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". gyermek életkora módosítva a következőre: " + d["1"] + "."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b865509666 = messageFormatterFn((function(  ) {
  return function(d) { return "1 év alatti"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a545608432 = messageFormatterFn((function(  ) {
  return function(d) { return "Gyermekek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1606348633 = messageFormatterFn((function(  ) {
  return function(d) { return "(0–17 éves)"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1218215590 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " felnőtt";}, one: function() { return number(d["0"]) + " felnőtt";}, two: function() { return number(d["0"]) + " felnőtt";}, few: function() { return number(d["0"]) + " felnőtt";}, many: function() { return number(d["0"]) + " felnőtt";}, other: function() { return number(d["0"]) + " felnőtt";} }); }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1402851744 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " gyermek";}, one: function() { return number(d["0"]) + " gyermek";}, two: function() { return number(d["0"]) + " gyermek";}, few: function() { return number(d["0"]) + " gyermek";}, many: function() { return number(d["0"]) + " gyermek";}, other: function() { return number(d["0"]) + " gyermek";} }); }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a971220982 = messageFormatterFn((function(  ) {
  return function(d) { return "Felnőttek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1943230094 = messageFormatterFn((function(  ) {
  return function(d) { return "Gyermekek számának csökkentése itt: " + d["0"] + ". szoba"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1257064712 = messageFormatterFn((function(  ) {
  return function(d) { return "Felnőttek számának csökkentése itt: " + d["0"] + ". szoba"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1177012402 = messageFormatterFn((function(  ) {
  return function(d) { return "Gyermekek számának növelése itt: " + d["0"] + ". szoba"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a415239124 = messageFormatterFn((function(  ) {
  return function(d) { return "Felnőttek számának növelése itt: " + d["0"] + ". szoba"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1886110464 = messageFormatterFn((function(  ) {
  return function(d) { return "Házi kedvencek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b642063716 = messageFormatterFn((function(  ) {
  return function(d) { return "Házi kedvenceket tartalmaz?"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a564380688 = messageFormatterFn((function(  ) {
  return function(d) { return "Igen"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b547501886 = messageFormatterFn((function(  ) {
  return function(d) { return "Nem"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1002426996 = messageFormatterFn((function(  ) {
  return function(d) { return "A(z) " + d["0"] + " felvéve a listáidra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1794939514 = messageFormatterFn((function(  ) {
  return function(d) { return "Új ablakban nyílik meg"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a274902757 = messageFormatterFn((function(  ) {
  return function(d) { return "Vendégek értékelései"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a788369539 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezárás és visszatérés a szállás adataihoz"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b801409611 = messageFormatterFn((function(  ) {
  return function(d) { return "Foglalható szobák mutatása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a166630624 = messageFormatterFn((function(  ) {
  return function(d) { return "Árak megtekintése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b756647122 = messageFormatterFn((function(  ) {
  return function(d) { return "Keresés módosítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b231530129 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz későbbi bejelentkezési dátumot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a822903243 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz korábbi bejelentkezési dátumot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1867751504 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz későbbi kijelentkezési dátumot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1372782420 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz korábbi kijelentkezési dátumot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a374922330 = messageFormatterFn((function(  ) {
  return function(d) { return "A korábbi ár " + d["0"] + " volt"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1443139156 = messageFormatterFn((function(  ) {
  return function(d) { return "Az ár " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1887137159 = messageFormatterFn((function(  ) {
  return function(d) { return "A jelenlegi ár " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a343893127 = messageFormatterFn((function(  ) {
  return function(d) { return "A korábbi ár " + d["0"] + " volt, a jelenlegi ár " + d["1"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1621620992 = messageFormatterFn((function(  ) {
  return function(d) { return "éjszakánként"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1051232688 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezárás és visszatérés a szállás adataihoz."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a262082952 = messageFormatterFn((function(  ) {
  return function(d) { return "További részletek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a397505682 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezárás és visszatérés a szállás adataihoz"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1665273020 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiba történt."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b935333130 = messageFormatterFn((function(  ) {
  return function(d) { return "Indíts új keresést!"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1257858577 = messageFormatterFn((function(  ) {
  return function(d) { return "Ezek is érdekelhetnek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a201724962 = messageFormatterFn((function(  ) {
  return function(d) { return "Szűrők bezárása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1969241002 = messageFormatterFn((function(  ) {
  return function(d) { return "Rendezés és szűrés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1447086196 = messageFormatterFn((function(  ) {
  return function(d) { return "Kész"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1723452489 = messageFormatterFn((function(  ) {
  return function(d) { return "Törlés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1260260430 = messageFormatterFn((function(  ) {
  return function(d) { return "Alkalmazd a szűrőket, vagy lépj vissza a szűrők bezárásához"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1470712528 = messageFormatterFn((function(  ) {
  return function(d) { return "Legalacsonyabb ár"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a591554914 = messageFormatterFn((function(  ) {
  return function(d) { return "Legmagasabb ár"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2095767847 = messageFormatterFn((function(  ) {
  return function(d) { return "Csillagbesorolás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b344718936 = messageFormatterFn((function(  ) {
  return function(d) { return "Rendezési szempont"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2071754743 = messageFormatterFn((function(  ) {
  return function(d) { return "Szűrés alapja:"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1128564041 = messageFormatterFn((function(  ) {
  return function(d) { return "Vissza a szálláskeresőhöz"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b112849107 = messageFormatterFn((function(  ) {
  return function(d) { return "Keresés szállások ezrei között"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2070295400 = messageFormatterFn((function(  ) {
  return function(d) { return "Keresés csomagajánlatok ezrei között"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1045146724 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " szűrő";}, one: function() { return number(d["0"]) + " szűrő";}, two: function() { return number(d["0"]) + " szűrő";}, few: function() { return number(d["0"]) + " szűrő";}, many: function() { return number(d["0"]) + " szűrő";}, other: function() { return number(d["0"]) + " szűrő";} }) + " alkalmazva"; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b588866532 = messageFormatterFn((function(  ) {
  return function(d) { return "Rendezés és szűrés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1220321744 = messageFormatterFn((function(  ) {
  return function(d) { return "Szűrő"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1290691651 = messageFormatterFn((function(  ) {
  return function(d) { return "Megnézem a térképen"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2034131418 = messageFormatterFn((function(  ) {
  return function(d) { return "az eredmények betöltése folyamatban van"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2046323589 = messageFormatterFn((function(  ) {
  return function(d) { return "eredmények frissítve"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a648887755 = messageFormatterFn((function(  ) {
  return function(d) { return "hiba történt az eredmények lekérésekor"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1745692041 = messageFormatterFn((function(  ) {
  return function(d) { return "az eredmények listája üres"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1048542453 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotelek keresése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1610943548 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezárás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1200320785 = messageFormatterFn((function(  ) {
  return function(d) { return "Próbálkozz inkább ezekkel a dátumokkal"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1648081835 = messageFormatterFn((function(  ) {
  return function(d) { return "Több dátum"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1685902951 = messageFormatterFn((function(  ) {
  return function(d) { return "Kevesebb dátum"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1524320598 = messageFormatterFn((function(  ) {
  return function(d) { return "A(z) " + d["0"] + " területén történő hotelkeresés eredményei"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b281010697 = messageFormatterFn((function(  ) {
  return function(d) { return "Érvénytelen hotelkeresési eredmények"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1603590645 = messageFormatterFn((function(  ) {
  return function(d) { return "Továbbiak megjelenítése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1960785105 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnos eredménytelen volt a keresés. Próbálkozz a keresési feltételek módosításával."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1214696967 = messageFormatterFn((function(  ) {
  return function(d) { return "Kiválasztott szűrő"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b733230679 = messageFormatterFn((function(  ) {
  return function(d) { return "Kiválasztott szűrők"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1741590487 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiányzik az úti cél"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1027464523 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " – " + d["1"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b304422187 = messageFormatterFn((function(  ) {
  return function(d) { return "Összes szűrő eltávolítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1517104276 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " utazó";}, one: function() { return number(d["0"]) + " utazó";}, two: function() { return number(d["0"]) + " utazó";}, few: function() { return number(d["0"]) + " utazó";}, many: function() { return number(d["0"]) + " utazó";}, other: function() { return number(d["0"]) + " utazó";} }); }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1090623956 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnáljuk, probléma merült fel a rendszerünkben"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2027750983 = messageFormatterFn((function(  ) {
  return function(d) { return "Újrapróbálkozás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a629143569 = messageFormatterFn((function(  ) {
  return function(d) { return "A(z) " + d["0"] + " mentése a listáidra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1919384441 = messageFormatterFn((function(  ) {
  return function(d) { return "A(z) " + d["0"] + " eltávolítása a listáidról"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a555465105 = messageFormatterFn((function(  ) {
  return function(d) { return "Adatok a következő foglalásodhoz"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a59039174 = messageFormatterFn((function(  ) {
  return function(d) { return "Keresés ezen a területen"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a543176620 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnos hiba történt. Próbálkozz újra a kereséssel"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a608621253 = messageFormatterFn((function(  ) {
  return function(d) { return "Térkép bezárása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b944696451 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " szálláshely";}, one: function() { return number(d["0"]) + " szálláshely";}, two: function() { return number(d["0"]) + " szálláshely";}, few: function() { return number(d["0"]) + " szálláshely";}, many: function() { return number(d["0"]) + " szálláshely";}, other: function() { return number(d["0"]) + " szálláshely";} }) + "\n" + d["1"] + " kezdőártól"; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1875289190 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " szálláshely";}, one: function() { return number(d["0"]) + " szálláshely";}, two: function() { return number(d["0"]) + " szálláshely";}, few: function() { return number(d["0"]) + " szálláshely";}, many: function() { return number(d["0"]) + " szálláshely";}, other: function() { return number(d["0"]) + " szálláshely";} }); }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a542259789 = messageFormatterFn((function(  ) {
  return function(d) { return "Több mutatása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b646137888 = messageFormatterFn((function(  ) {
  return function(d) { return "Kevesebb mutatása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b998040014 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnos hiba történt a rendszerünkben"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a384678270 = messageFormatterFn((function(  ) {
  return function(d) { return "Következő tétel"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a698785794 = messageFormatterFn((function(  ) {
  return function(d) { return "Előző tétel"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1442424539 = messageFormatterFn((function(  ) {
  return function(d) { return "Fizetés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b959996346 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Az utazásod (" + plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " szoba";}, one: function() { return number(d["0"]) + " szoba";}, two: function() { return number(d["0"]) + " szoba";}, few: function() { return number(d["0"]) + " szoba";}, many: function() { return number(d["0"]) + " szoba";}, other: function() { return number(d["0"]) + " szoba";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1920235567 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Az utazásod (" + plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " szállás";}, one: function() { return number(d["0"]) + " szállás";}, two: function() { return number(d["0"]) + " szállás";}, few: function() { return number(d["0"]) + " szállás";}, many: function() { return number(d["0"]) + " szállás";}, other: function() { return number(d["0"]) + " szállás";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1981606411 = messageFormatterFn((function(  ) {
  return function(d) { return "Válaszd ki a következő szobát"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1060186792 = messageFormatterFn((function(  ) {
  return function(d) { return "Már nem foglalható"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a322494028 = messageFormatterFn((function(  ) {
  return function(d) { return "Az utazásodhoz hozzáadott egy vagy több szállás már nem foglalható le. Így is továbblépsz a fizetéshez?"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1085060755 = messageFormatterFn((function(  ) {
  return function(d) { return "szobánként"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1055783013 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " vendég";}, one: function() { return number(d["0"]) + " vendég";}, two: function() { return number(d["0"]) + " vendég";}, few: function() { return number(d["0"]) + " vendég";}, many: function() { return number(d["0"]) + " vendég";}, other: function() { return number(d["0"]) + " vendég";} }); }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2010347073 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " szoba";}, one: function() { return number(d["0"]) + " szoba";}, two: function() { return number(d["0"]) + " szoba";}, few: function() { return number(d["0"]) + " szoba";}, many: function() { return number(d["0"]) + " szoba";}, other: function() { return number(d["0"]) + " szoba";} }) + ", " + plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " vendég";}, one: function() { return number(d["1"]) + " vendég";}, two: function() { return number(d["1"]) + " vendég";}, few: function() { return number(d["1"]) + " vendég";}, many: function() { return number(d["1"]) + " vendég";}, other: function() { return number(d["1"]) + " vendég";} }); }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1357615180 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " éjszakánként"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1501519340 = messageFormatterFn((function(  ) {
  return function(d) { return "Szoba cseréje"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b96407288 = messageFormatterFn((function(  ) {
  return function(d) { return "A kód a vágólapra másolva."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b788867999 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnáljuk, probléma merült fel a rendszerünkben"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b489807394 = messageFormatterFn((function(  ) {
  return function(d) { return "Kérjük, próbálkozz új kereséssel"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b453301816 = messageFormatterFn((function(  ) {
  return function(d) { return "Újra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1002166731 = messageFormatterFn((function(  ) {
  return function(d) { return "Bérautó felvétele és leadása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a213066156 = messageFormatterFn((function(  ) {
  return function(d) { return "Felvétel időpontja"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1823699264 = messageFormatterFn((function(  ) {
  return function(d) { return "Leadás időpontja"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b313417249 = messageFormatterFn((function(  ) {
  return function(d) { return "Autóbérlés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1653649460 = messageFormatterFn((function(  ) {
  return function(d) { return "A leadás időpontjának legalább két órával a felvétel időpontja után kell lennie."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1233499384 = messageFormatterFn((function(  ) {
  return function(d) { return "0:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1233588757 = messageFormatterFn((function(  ) {
  return function(d) { return "0:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1234422905 = messageFormatterFn((function(  ) {
  return function(d) { return "1:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1234512278 = messageFormatterFn((function(  ) {
  return function(d) { return "1:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1235346426 = messageFormatterFn((function(  ) {
  return function(d) { return "2:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1235435799 = messageFormatterFn((function(  ) {
  return function(d) { return "2:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1236269947 = messageFormatterFn((function(  ) {
  return function(d) { return "3:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1236359320 = messageFormatterFn((function(  ) {
  return function(d) { return "3:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1237193468 = messageFormatterFn((function(  ) {
  return function(d) { return "4:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1237282841 = messageFormatterFn((function(  ) {
  return function(d) { return "4:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1238116989 = messageFormatterFn((function(  ) {
  return function(d) { return "5:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1238206362 = messageFormatterFn((function(  ) {
  return function(d) { return "5:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1239040510 = messageFormatterFn((function(  ) {
  return function(d) { return "6:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1239129883 = messageFormatterFn((function(  ) {
  return function(d) { return "6:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1239964031 = messageFormatterFn((function(  ) {
  return function(d) { return "7:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1240053404 = messageFormatterFn((function(  ) {
  return function(d) { return "7:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1240887552 = messageFormatterFn((function(  ) {
  return function(d) { return "8:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1240976925 = messageFormatterFn((function(  ) {
  return function(d) { return "8:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1241811073 = messageFormatterFn((function(  ) {
  return function(d) { return "9:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1241900446 = messageFormatterFn((function(  ) {
  return function(d) { return "9:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1262128535 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1262217908 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1263052056 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1263141429 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1263975577 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1264064950 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1264899098 = messageFormatterFn((function(  ) {
  return function(d) { return "13:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1264988471 = messageFormatterFn((function(  ) {
  return function(d) { return "13:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1265822619 = messageFormatterFn((function(  ) {
  return function(d) { return "14:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1265911992 = messageFormatterFn((function(  ) {
  return function(d) { return "14:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1266746140 = messageFormatterFn((function(  ) {
  return function(d) { return "15:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1266835513 = messageFormatterFn((function(  ) {
  return function(d) { return "15:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1267669661 = messageFormatterFn((function(  ) {
  return function(d) { return "16:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1267759034 = messageFormatterFn((function(  ) {
  return function(d) { return "16:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1268593182 = messageFormatterFn((function(  ) {
  return function(d) { return "17:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1268682555 = messageFormatterFn((function(  ) {
  return function(d) { return "17:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1269516703 = messageFormatterFn((function(  ) {
  return function(d) { return "18:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1269606076 = messageFormatterFn((function(  ) {
  return function(d) { return "18:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1270440224 = messageFormatterFn((function(  ) {
  return function(d) { return "19:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1270529597 = messageFormatterFn((function(  ) {
  return function(d) { return "19:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1290757686 = messageFormatterFn((function(  ) {
  return function(d) { return "20:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1290847059 = messageFormatterFn((function(  ) {
  return function(d) { return "20:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1291681207 = messageFormatterFn((function(  ) {
  return function(d) { return "21:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1291770580 = messageFormatterFn((function(  ) {
  return function(d) { return "21:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1292604728 = messageFormatterFn((function(  ) {
  return function(d) { return "22:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1292694101 = messageFormatterFn((function(  ) {
  return function(d) { return "22:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1293528249 = messageFormatterFn((function(  ) {
  return function(d) { return "23:00"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1293617622 = messageFormatterFn((function(  ) {
  return function(d) { return "23:30"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1252288839 = messageFormatterFn((function(  ) {
  return function(d) { return "Csak közvetlen járatok"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1520698228 = messageFormatterFn((function(  ) {
  return function(d) { return "Preferált osztály"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b774299020 = messageFormatterFn((function(  ) {
  return function(d) { return "Turista"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1349392877 = messageFormatterFn((function(  ) {
  return function(d) { return "Prémium turista"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1639478996 = messageFormatterFn((function(  ) {
  return function(d) { return "Business"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1128425300 = messageFormatterFn((function(  ) {
  return function(d) { return "Első osztály"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b207565781 = messageFormatterFn((function(  ) {
  return function(d) { return "Utazók"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b644292553 = messageFormatterFn((function(  ) {
  return function(d) { return "Minden ölben utazó csecsemőre kell jutnia legalább egy (6 éves vagy idősebb) utazónak."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2110790002 = messageFormatterFn((function(  ) {
  return function(d) { return "Csecsemők"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a188564475 = messageFormatterFn((function(  ) {
  return function(d) { return "(2–17 éves)"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b529432169 = messageFormatterFn((function(  ) {
  return function(d) { return "2 évesnél kisebbek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1873911845 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". csecsemő életkora"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b562119775 = messageFormatterFn((function(  ) {
  return function(d) { return "Csecsemők számának csökkentése itt: " + d["0"] + ". szoba"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1609621117 = messageFormatterFn((function(  ) {
  return function(d) { return "Csecsemők számának növelése itt: " + d["0"] + ". szoba"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a267855119 = messageFormatterFn((function(  ) {
  return function(d) { return "A 2 éven aluli gyermekeknek ülésen vagy ölben kell utazniuk"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b415085193 = messageFormatterFn((function(  ) {
  return function(d) { return "Ölben"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b531047797 = messageFormatterFn((function(  ) {
  return function(d) { return "Ülésen"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1006192780 = messageFormatterFn((function(  ) {
  return function(d) { return "Légitársaság életkori előírásai"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1624706816 = messageFormatterFn((function(  ) {
  return function(d) { return "Indulás helye"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a283874056 = messageFormatterFn((function(  ) {
  return function(d) { return "Indulás dátuma"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a322776388 = messageFormatterFn((function(  ) {
  return function(d) { return "Visszaút dátuma"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1570511586 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz indulási helyet"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b431231676 = messageFormatterFn((function(  ) {
  return function(d) { return "Csak az utazásom egy részére kell szállás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b932899325 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnos hiba történt a rendszerünkben. Kérjük, próbálkozz újra."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1845617521 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz ki még legalább 1 szálláshelyet az összehasonlításhoz"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b601343438 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " szálláshely";}, one: function() { return number(d["1"]) + " szálláshely";}, two: function() { return number(d["1"]) + " szálláshely";}, few: function() { return number(d["1"]) + " szálláshely";}, many: function() { return number(d["1"]) + " szálláshely";}, other: function() { return number(d["1"]) + " szálláshely";} }) + "/" + d["0"] + " kiválasztva"; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1336348458 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " szálláshely";}, one: function() { return number(d["1"]) + " szálláshely";}, two: function() { return number(d["1"]) + " szálláshely";}, few: function() { return number(d["1"]) + " szálláshely";}, many: function() { return number(d["1"]) + " szálláshely";}, other: function() { return number(d["1"]) + " szálláshely";} }) + " közül " + d["0"] + " kiválasztva összehasonlításra"; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a112246712 = messageFormatterFn((function(  ) {
  return function(d) { return "Összehasonlítás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1397951844 = messageFormatterFn((function(  ) {
  return function(d) { return "Kiválasztott szálláshelyek összehasonlítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b438652290 = messageFormatterFn((function(  ) {
  return function(d) { return "Összehasonlítás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b865081762 = messageFormatterFn((function(  ) {
  return function(d) { return "Kiválasztott szálláshelyek összehasonlítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1666654544 = messageFormatterFn((function(  ) {
  return function(d) { return "Megtekintés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2011294412 = messageFormatterFn((function(  ) {
  return function(d) { return "Kattints rá a szálláshely megtekintéséhez"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2074949777 = messageFormatterFn((function(  ) {
  return function(d) { return "Eltávolítás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a891568141 = messageFormatterFn((function(  ) {
  return function(d) { return "Kattints rá a szálláshely eltávolításához az összehasonlításból"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a167886722 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezárás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b306420922 = messageFormatterFn((function(  ) {
  return function(d) { return "Visszavonás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1226166316 = messageFormatterFn((function(  ) {
  return function(d) { return "Elvetés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1422243470 = messageFormatterFn((function(  ) {
  return function(d) { return "Kész"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b696069424 = messageFormatterFn((function(  ) {
  return function(d) { return "Eltávolítás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1660341529 = messageFormatterFn((function(  ) {
  return function(d) { return "kiválasztva"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a13007366 = messageFormatterFn((function(  ) {
  return function(d) { return "Betöltés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a158127767 = messageFormatterFn((function(  ) {
  return function(d) { return "Törlés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1874407663 = messageFormatterFn((function(  ) {
  return function(d) { return "Új ablakban nyílik meg"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a816458283 = messageFormatterFn((function(  ) {
  return function(d) { return "Több mutatása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a731284536 = messageFormatterFn((function(  ) {
  return function(d) { return "Kevesebb mutatása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1396856492 = messageFormatterFn((function(  ) {
  return function(d) { return "Több megjelenítése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a148214905 = messageFormatterFn((function(  ) {
  return function(d) { return "Kevesebb megjelenítése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b443764718 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " kiválasztva. Most válassza ki a kijelentkezés dátumát."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1554727871 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " kiválasztva. Most válassza a kész lehetőséget a dátumok mentéséhez és a dátumválasztó bezárásához."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1739373917 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", jelenlegi bejelentkezési dátum"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1638957474 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", jelenlegi kijelentkezési dátum"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1024952396 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", dátum letiltva"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1624834959 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", aktuális hónap"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a672691348 = messageFormatterFn((function(  ) {
  return function(d) { return "Most ezek jelennek meg: " + d["0"] + " " + d["1"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2098522408 = messageFormatterFn((function(  ) {
  return function(d) { return "Dátumválasztó megnyitva. Válasszon egy dátumot az alábbi táblázatokból."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1202487990 = messageFormatterFn((function(  ) {
  return function(d) { return "Megszakítás, a dátumválasztó bezárása a módosítások mentése nélkül. Vagy válasszon egy dátumot az alábbi táblázatokból."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b624521254 = messageFormatterFn((function(  ) {
  return function(d) { return "A kiválasztott dátumok eltávolítása."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a736245169 = messageFormatterFn((function(  ) {
  return function(d) { return "A módosítások mentése és a dátumválasztó bezárása."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b669884150 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " éjszaka";}, one: function() { return number(d["0"]) + " éjszaka";}, two: function() { return number(d["0"]) + " éjszaka";}, few: function() { return number(d["0"]) + " éjszaka";}, many: function() { return number(d["0"]) + " éjszaka";}, other: function() { return number(d["0"]) + " éjszaka";} }); }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1531178918 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b288310805 = messageFormatterFn((function(  ) {
  return function(d) { return "Kijelentkezés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a68144500 = messageFormatterFn((function(  ) {
  return function(d) { return "Dátumok törlése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a793248075 = messageFormatterFn((function(  ) {
  return function(d) { return "Kész"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a482363697 = messageFormatterFn((function(  ) {
  return function(d) { return "Keresés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1665781287 = messageFormatterFn((function(  ) {
  return function(d) { return "A bejelentkezési dátum szerkesztése az alábbi táblázatokban."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b652003912 = messageFormatterFn((function(  ) {
  return function(d) { return "A kijelentkezési dátum szerkesztése az alábbi táblázatokban."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1103254969 = messageFormatterFn((function(  ) {
  return function(d) { return "kiválasztva."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a555771860 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " kiválasztva. Zárd be a dátumválasztót, vagy folytasd a kiválasztott dátum módosításával."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1808615644 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " és " + d["1"] + " közötti időszak kiválasztva. Zárd be a dátumválasztót, vagy folytasd a kiválasztott dátumok módosításával."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b439659230 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " kiválasztva. " + d["1"] + ". Zárd be a dátumválasztót, vagy folytasd a kiválasztott dátum módosításával."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1317922134 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " és " + d["1"] + " közötti időszak kiválasztva. " + d["2"] + ". Zárd be a dátumválasztót, vagy folytasd a kiválasztott dátumok módosításával."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a551655037 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz bejelentkezési dátumot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1900023286 = messageFormatterFn((function(  ) {
  return function(d) { return "Válassz kijelentkezési dátumot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1969439259 = messageFormatterFn((function(  ) {
  return function(d) { return "üres"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1714670461 = messageFormatterFn((function(  ) {
  return function(d) { return "Előző hónap"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a802557031 = messageFormatterFn((function(  ) {
  return function(d) { return "Következő hónap"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2053747384 = messageFormatterFn((function(  ) {
  return function(d) { return "Ugrás ehhez a gombhoz: " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1303919392 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " és " + d["1"] + " között"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1872928221 = messageFormatterFn((function(  ) {
  return function(d) { return "Dátumok törölve"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b240868688 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " eredményt";}, one: function() { return number(d["0"]) + " eredményt";}, two: function() { return number(d["0"]) + " eredményt";}, few: function() { return number(d["0"]) + " eredményt";}, many: function() { return number(d["0"]) + " eredményt";}, other: function() { return number(d["0"]) + " eredményt";} }) + " találtunk"; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2083977799 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "„" + d["0"] + "”, " + plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " eredményt";}, one: function() { return number(d["1"]) + " eredményt";}, two: function() { return number(d["1"]) + " eredményt";}, few: function() { return number(d["1"]) + " eredményt";}, many: function() { return number(d["1"]) + " eredményt";}, other: function() { return number(d["1"]) + " eredményt";} }) + " találtunk. A listában a nyílbillentyűkkel vagy az ujjad elhúzásával navigálhatsz."; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1831899565 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " keresése megnyitva, adj meg keresőszót."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b577335454 = messageFormatterFn((function(  ) {
  return function(d) { return "A következőt választottad: " + d["0"] + "."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2079321919 = messageFormatterFn((function(  ) {
  return function(d) { return "A menü be van zárva."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1693261317 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " keresése megnyitva, jelenleg " + plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " javaslat";}, one: function() { return number(d["1"]) + " javaslat";}, two: function() { return number(d["1"]) + " javaslat";}, few: function() { return number(d["1"]) + " javaslat";}, many: function() { return number(d["1"]) + " javaslat";}, other: function() { return number(d["1"]) + " javaslat";} }) + " jelenik meg a következőre: " + d["2"] + ". Lépj az alábbi listára."; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1054841454 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " keresése megnyitva, " + plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " javaslat";}, one: function() { return number(d["1"]) + " javaslat";}, two: function() { return number(d["1"]) + " javaslat";}, few: function() { return number(d["1"]) + " javaslat";}, many: function() { return number(d["1"]) + " javaslat";}, other: function() { return number(d["1"]) + " javaslat";} }) + " jelenik meg. Adj meg egy keresőszót, vagy lépj az alábbi listára."; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a164771634 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " keresése megnyitva, jelenleg a következő van kijelölve: " + d["1"] + ". " + plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " javaslat";}, one: function() { return number(d["1"]) + " javaslat";}, two: function() { return number(d["1"]) + " javaslat";}, few: function() { return number(d["1"]) + " javaslat";}, many: function() { return number(d["1"]) + " javaslat";}, other: function() { return number(d["1"]) + " javaslat";} }) + " jelenik meg a következőre: " + d["3"] + ". Lépj az alábbi listára."; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b35537036 = messageFormatterFn((function(  ) {
  return function(d) { return "Kész"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1572061525 = messageFormatterFn((function(  ) {
  return function(d) { return "Összes törlése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1186293314 = messageFormatterFn((function(  ) {
  return function(d) { return "Kijelölt elemek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a513232395 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " eltávolítva."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1893596626 = messageFormatterFn((function(  ) {
  return function(d) { return "Minden kijelölés törölve."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1972426621 = messageFormatterFn((function(  ) {
  return function(d) { return "Belépett a beviteli szövegmezőbe. Kérjük, végezzen keresést, vagy válasszon az alábbi ajánlott kategóriák közül."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a733432420 = messageFormatterFn((function(  ) {
  return function(d) { return "„" + d["0"] + "” keresése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1039776477 = messageFormatterFn((function(  ) {
  return function(d) { return "Nincs találat a következőre: „" + d["0"] + "”"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b587158983 = messageFormatterFn((function(  ) {
  return function(d) { return "Repülőtér"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a543869346 = messageFormatterFn((function(  ) {
  return function(d) { return "Szállás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2001235320 = messageFormatterFn((function(  ) {
  return function(d) { return "Látnivaló"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1246982559 = messageFormatterFn((function(  ) {
  return function(d) { return "A közelben"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a993154462 = messageFormatterFn((function(  ) {
  return function(d) { return "Próbáld ki a(z) „" + d["0"] + "” keresőszót"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1833845383 = messageFormatterFn((function(  ) {
  return function(d) { return "Régió/város"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1757888389 = messageFormatterFn((function(  ) {
  return function(d) { return "Repülőtér"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b573788989 = messageFormatterFn((function(  ) {
  return function(d) { return "Látnivaló"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1328431598 = messageFormatterFn((function(  ) {
  return function(d) { return "Szálloda"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2141673582 = messageFormatterFn((function(  ) {
  return function(d) { return "Cím"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a976347624 = messageFormatterFn((function(  ) {
  return function(d) { return "Vasútállomás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1292039689 = messageFormatterFn((function(  ) {
  return function(d) { return "Metróállomás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b718632357 = messageFormatterFn((function(  ) {
  return function(d) { return "Közeli helyek felfedezése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1302333170 = messageFormatterFn((function(  ) {
  return function(d) { return "Legutóbbi keresések"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2040967092 = messageFormatterFn((function(  ) {
  return function(d) { return "Mások ezekre is rákerestek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1148870465 = messageFormatterFn((function(  ) {
  return function(d) { return "Fedezd fel a népszerű úti célokat"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a647662099 = messageFormatterFn((function(  ) {
  return function(d) { return "Népszerű úti célok"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1800228215 = messageFormatterFn((function(  ) {
  return function(d) { return "Felkapott úti célok"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1225030645 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelenlegi hely"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1031492216 = messageFormatterFn((function(  ) {
  return function(d) { return "Hely megosztása kikapcsolva"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2064664008 = messageFormatterFn((function(  ) {
  return function(d) { return "Nem tudjuk meghatározni, hol vagy. Kérjük, kapcsold be a helymeghatározást az eszközödön, hogy meg tudjuk határozni a tartózkodási helyedet, vagy írj be egy úti célt."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1893260764 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " szoba";}, one: function() { return number(d["0"]) + " szoba";}, two: function() { return number(d["0"]) + " szoba";}, few: function() { return number(d["0"]) + " szoba";}, many: function() { return number(d["0"]) + " szoba";}, other: function() { return number(d["0"]) + " szoba";} }) + ", " + plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " utazó";}, one: function() { return number(d["1"]) + " utazó";}, two: function() { return number(d["1"]) + " utazó";}, few: function() { return number(d["1"]) + " utazó";}, many: function() { return number(d["1"]) + " utazó";}, other: function() { return number(d["1"]) + " utazó";} }); }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1080576682 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " mező jelenlegi értéke " + d["1"] + ". " + d["2"] + " mező jelenlegi értéke " + d["3"] + "."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1915851673 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " és " + d["1"] + " mező felcserélése."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1669588730 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó megjelenítése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1355246591 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó elrejtése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2071541240 = messageFormatterFn((function(  ) {
  return function(d) { return "Most ez jelenik meg: " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1951000675 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " közül " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1737316807 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". kép " + d["1"] + " közül. " + d["2"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1469437706 = messageFormatterFn((function(  ) {
  return function(d) { return "Következő kép megjelenítése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b594916622 = messageFormatterFn((function(  ) {
  return function(d) { return "Előző kép megjelenítése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a844120360 = messageFormatterFn((function(  ) {
  return function(d) { return "Az összes kép megjelenítése (" + d["0"] + " kép)"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b313111219 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "A(z) " + d["1"] + " " + plural(d["0"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["0"]) + " képének";}, one: function() { return number(d["0"]) + " képének";}, two: function() { return number(d["0"]) + " képének";}, few: function() { return "mind a(z) " + number(d["0"]) + " képének";}, many: function() { return "mind a(z) " + number(d["0"]) + " képének";}, other: function() { return "mind a(z) " + number(d["0"]) + " képének";} }) + " megjelenítése"; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b933060470 = messageFormatterFn((function(  ) {
  return function(d) { return "Befejezve:"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b335960776 = messageFormatterFn((function(  ) {
  return function(d) { return "Most itt tartasz:"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a40605798 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + "/" + d["0"] + ". lépés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1535799670 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". lépés " + d["1"] + " közül:"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1025066039 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". kép " + d["1"] + " közül. " + d["2"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1232875124 = messageFormatterFn((function(  ) {
  return function(d) { return "Következő kép"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b234790544 = messageFormatterFn((function(  ) {
  return function(d) { return "Előző kép"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2129180994 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", megjelenítés teljes képernyős nézetben"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b600801770 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". elem, megjelenítés teljes képernyős nézetben"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a569949908 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelenlegi oldal"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1404200156 = messageFormatterFn((function(  ) {
  return function(d) { return "További webhely-navigációs elemek megjelenítése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1366379040 = messageFormatterFn((function(  ) {
  return function(d) { return "Kevesebb webhely-navigációs elem megjelenítése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a239479363 = messageFormatterFn((function(  ) {
  return function(d) { return "Betöltés, " + d["0"] + " százalék"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a252417278 = messageFormatterFn((function(  ) {
  return function(d) { return "Betöltés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a153686002 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + ", " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1335033015 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiba történt. "; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1870242963 = messageFormatterFn((function(  ) {
  return function(d) { return "Próbáld meg megnézni ezt a videót a www.youtube.com oldalon, vagy ha ki van kapcsolva, kapcsold be a JavaScript-támogatást a böngésződben."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b667072213 = messageFormatterFn((function(  ) {
  return function(d) { return "Videó lejátszása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a44812965 = messageFormatterFn((function(  ) {
  return function(d) { return "Videó szüneteltetése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1192490877 = messageFormatterFn((function(  ) {
  return function(d) { return "Videó betöltése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1643325171 = messageFormatterFn((function(  ) {
  return function(d) { return "360 fokos kép"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b38242221 = messageFormatterFn((function(  ) {
  return function(d) { return "Ez egy 360 fokos kép. A Control billentyűvel és nyílbillentyűkkel, illetve a Command billentyűvel és a nyílbillentyűkkel mozgathatod"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b403081728 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelenleg ezt látod: " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1872335263 = messageFormatterFn((function(  ) {
  return function(d) { return "Nézet balra elfordítva. Pozíció: " + d["0"] + " fok"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b941934502 = messageFormatterFn((function(  ) {
  return function(d) { return "Nézet jobbra elfordítva. Pozíció: " + d["0"] + " fok"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1848032883 = messageFormatterFn((function(  ) {
  return function(d) { return "Nézet felfelé elfordítva."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1653037946 = messageFormatterFn((function(  ) {
  return function(d) { return "Nézet felfelé elfordítva."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b173860619 = messageFormatterFn((function(  ) {
  return function(d) { return "Legfelül vagy"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b866069151 = messageFormatterFn((function(  ) {
  return function(d) { return "Legalul vagy"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b431971403 = messageFormatterFn((function(  ) {
  return function(d) { return "Összes sor kiválasztása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1862545132 = messageFormatterFn((function(  ) {
  return function(d) { return "Összes sorkijelölés törlése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a190700836 = messageFormatterFn((function(  ) {
  return function(d) { return "Oszlop rendezése csökkenő sorrendben"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b54417534 = messageFormatterFn((function(  ) {
  return function(d) { return "Oszlop rendezése növekvő sorrendben"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a819339986 = messageFormatterFn((function(  ) {
  return function(d) { return "Az oszlop csökkenő sorrendbe van rendezve"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a851164566 = messageFormatterFn((function(  ) {
  return function(d) { return "Az oszlop növekvő sorrendbe van rendezve"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1636893490 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". sor kibontása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b463158769 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["hu-HU"], { zero: function() { return number(d["1"]) + " elem";}, one: function() { return number(d["1"]) + " elem";}, two: function() { return number(d["1"]) + " elem";}, few: function() { return number(d["1"]) + " elem";}, many: function() { return number(d["1"]) + " elem";}, other: function() { return number(d["1"]) + " elem";} }) + " közül " + d["0"] + " jelenik meg"; }
})(messageFormat.number, messageFormat.plural, {"hu-HU": Globalize("hu-HU").pluralGenerator()}), Globalize("hu-HU").pluralGenerator({}));
Globalize.b925756449 = messageFormatterFn((function(  ) {
  return function(d) { return "jelenleg " + d["1"] + ". " + d["0"] + " és " + d["3"] + ". " + d["2"] + " jelenik meg."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1152447367 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezési dátum törölve."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a957910832 = messageFormatterFn((function(  ) {
  return function(d) { return "Kijelentkezési dátum törölve."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1511223791 = messageFormatterFn((function(  ) {
  return function(d) { return "Dátumok törölve."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b970457267 = messageFormatterFn((function(  ) {
  return function(d) { return "Következő"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b515258739 = messageFormatterFn((function(  ) {
  return function(d) { return "Előző"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1520016750 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " kiválasztva bejelentkezési dátumként."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1039285257 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " kiválasztva kijelentkezési dátumként."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a955084206 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " nem érvényes bejelentkezési dátum."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b36162985 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " nem érvényes kijelentkezési dátum."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1600826746 = messageFormatterFn((function(  ) {
  return function(d) { return "Erre a napra nem foglalható: " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b369934421 = messageFormatterFn((function(  ) {
  return function(d) { return "Ma"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a8191380 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " közül " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1459723107 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1679327081 = messageFormatterFn((function(  ) {
  return function(d) { return "Üdvözöljük ismét! Jelentkezzen be, hogy részesülhessen a tagoknak szóló árakból, és ezzel további 10%-ot vagy még többet spórolhasson több ezer szállás árából."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2076025475 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail-cím"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b623496342 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1387223591 = messageFormatterFn((function(  ) {
  return function(d) { return "Szüksége van egy fiókra?"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a186474805 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés folyamatban"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a844751432 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés Facebookkal"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b940307781 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés Google-lal"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1276543979 = messageFormatterFn((function(  ) {
  return function(d) { return "Maradjak bejelentkezve"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1542795602 = messageFormatterFn((function(  ) {
  return function(d) { return "Maradjak bejelentkezve (cookie-kat használ)"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b427564188 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b427204774 = messageFormatterFn((function(  ) {
  return function(d) { return "Regisztráció"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b323942794 = messageFormatterFn((function(  ) {
  return function(d) { return "Vagy <a href=\"" + d["0"] + "\">jelentkezzen be Facebookkal</a>"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a961525888 = messageFormatterFn((function(  ) {
  return function(d) { return "Elfelejtett jelszó"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b399264109 = messageFormatterFn((function(  ) {
  return function(d) { return "Adja meg az e-mail-címet"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1232066665 = messageFormatterFn((function(  ) {
  return function(d) { return "Adjon meg egy érvényes e-mail-címet"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1681988262 = messageFormatterFn((function(  ) {
  return function(d) { return "Adja meg a jelszót"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a964558304 = messageFormatterFn((function(  ) {
  return function(d) { return "Kérjük, próbálkozzon újra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2031275484 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoppá, valami hiba történt"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1549559038 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatáshoz javítsa az alábbi hibát"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a619824985 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatáshoz javítsa az alábbi 2 hibát"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a913079055 = messageFormatterFn((function(  ) {
  return function(d) { return "Mi az e-mail-címe?"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1987836185 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-fiókját egy telefonszámmal hozta létre. Kérjük, adjon meg egy e-mail-címet, hogy befejezhessük a bejelentkeztetését. Egy biztonsági kódot fogok küldeni Önnek, hogy ellenőrizzük személyazonosságát."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2001944199 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-fiókját egy telefonszámmal hozta létre. Kérjük, adjon meg egy e-mail-címet, hogy befejezhessük " + d["1"] + "-fiókja felállítását. Egy biztonsági kódot fogok küldeni Önnek, hogy ellenőrizzük személyazonosságát."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b38624806 = messageFormatterFn((function(  ) {
  return function(d) { return "Biztonsági kód küldése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1726270348 = messageFormatterFn((function(  ) {
  return function(d) { return "Biztonsági kód megadása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b245800820 = messageFormatterFn((function(  ) {
  return function(d) { return "Kérjük, adja meg a biztonsági kódot, melyet a következő elérhetőségre küldtünk: " + d["0"] + "."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a713728810 = messageFormatterFn((function(  ) {
  return function(d) { return "Már csak 1 lépésre van fiókja létrehozásától. Kérjük, adja meg a biztonsági kódot, melyet a következő elérhetőségre küldtünk: " + d["0"] + "."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b637103037 = messageFormatterFn((function(  ) {
  return function(d) { return "Biztonsági kód"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1616993087 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiók létrehozása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b250000139 = messageFormatterFn((function(  ) {
  return function(d) { return "Nem kapott e-mailt?"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b415957329 = messageFormatterFn((function(  ) {
  return function(d) { return "Új kód küldése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a295388172 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailben elküldtünk Önnek egy új biztonsági kódot."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2021762073 = messageFormatterFn((function(  ) {
  return function(d) { return "Biztonsági kód megadása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b160402799 = messageFormatterFn((function(  ) {
  return function(d) { return "Adjon meg egy érvényes biztonsági kódot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b291414003 = messageFormatterFn((function(  ) {
  return function(d) { return "Elnézést kérünk, hiba történt a rendszerünkben."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2034467301 = messageFormatterFn((function(  ) {
  return function(d) { return "Kérjük, próbálkozzon újra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a84589954 = messageFormatterFn((function(  ) {
  return function(d) { return "1 éjszaka"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a39508362 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " éjszaka"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1086761354 = messageFormatterFn((function(  ) {
  return function(d) { return "Kész, egy éjszaka kiválasztva. A módosítások mentése és a dátumválasztó bezárása."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b412805378 = messageFormatterFn((function(  ) {
  return function(d) { return "Kész, " + d["0"] + " éjszaka kiválasztva. A módosítások mentése és a dátumválasztó bezárása."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b373545733 = messageFormatterFn((function(  ) {
  return function(d) { return "Dátum kiválasztása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1704914268 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " eredmény található"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b341805796 = messageFormatterFn((function(  ) {
  return function(d) { return "1 eredmény található"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a856014872 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b258531496 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1802632789 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1369880549 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b204390472 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a946037677 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a1593331544 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b150249448 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a379244824 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b2044204181 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b922810440 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.a1200144711 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"V","mon":"H","tue":"K","wed":"Sz","thu":"Cs","fri":"P","sat":"Sz"}}}});
Globalize.b515505832 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"vasárnap","mon":"hétfő","tue":"kedd","wed":"szerda","thu":"csütörtök","fri":"péntek","sat":"szombat"}}}});
Globalize.b1768751272 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"január","2":"február","3":"március","4":"április","5":"május","6":"június","7":"július","8":"augusztus","9":"szeptember","10":"október","11":"november","12":"december"}}}});
Globalize.b128301944 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b1548577589 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"}),"2":Globalize("hu-HU").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.b120411626 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"MMM d.","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"febr.","3":"márc.","4":"ápr.","5":"máj.","6":"jún.","7":"júl.","8":"aug.","9":"szept.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a542845747 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"MMMM d.","timeSeparator":":","months":{"M":{"4":{"1":"január","2":"február","3":"március","4":"április","5":"május","6":"június","7":"július","8":"augusztus","9":"szeptember","10":"október","11":"november","12":"december"}}}});
Globalize.a1705370082 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"y. MMMM d.","timeSeparator":":","months":{"M":{"4":{"1":"január","2":"február","3":"március","4":"április","5":"május","6":"június","7":"július","8":"augusztus","9":"szeptember","10":"október","11":"november","12":"december"}}}});
Globalize.b83596034 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"y. MMMM","timeSeparator":":","months":{"M":{"4":{"1":"január","2":"február","3":"március","4":"április","5":"május","6":"június","7":"július","8":"augusztus","9":"szeptember","10":"október","11":"november","12":"december"}}}});
Globalize.b82910841 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"y. MMM d.","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"febr.","3":"márc.","4":"ápr.","5":"máj.","6":"jún.","7":"júl.","8":"aug.","9":"szept.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b484063402 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"MMM d., EEEE","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"febr.","3":"márc.","4":"ápr.","5":"máj.","6":"jún.","7":"júl.","8":"aug.","9":"szept.","10":"okt.","11":"nov.","12":"dec."}}},"days":{"E":{"4":{"sun":"vasárnap","mon":"hétfő","tue":"kedd","wed":"szerda","thu":"csütörtök","fri":"péntek","sat":"szombat"}}}});
Globalize.a535457579 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"MMM d., E","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"febr.","3":"márc.","4":"ápr.","5":"máj.","6":"jún.","7":"júl.","8":"aug.","9":"szept.","10":"okt.","11":"nov.","12":"dec."}}},"days":{"E":{"1":{"sun":"V","mon":"H","tue":"K","wed":"Sze","thu":"Cs","fri":"P","sat":"Szo"}}}});
Globalize.a1234728623 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a120182255 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a12284418 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b1110169540 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a174323279 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1534012412 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a1972045295 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a228464303 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a757958575 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b229286974 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b544096689 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.a1048971344 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1351666385 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1690055471 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a454981649 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"d"}));
Globalize.b1939984670 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a307446943 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a921559498 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a560594475 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a295117717 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a295802910 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b1101793953 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a914171330 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b1446176930 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a1734243998 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b777096591 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b1899550549 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a1788385022 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a1971573875 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b708860258 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a1842526046 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1922946978 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b1018667983 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a1069965054 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b1439861183 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["wed",/^Sz/],["thu",/^Cs/],["sat",/^Sz/],["sun",/^V/],["mon",/^H/],["tue",/^K/],["fri",/^P/]]});
Globalize.a2031731998 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^csütörtök/],["sun",/^vasárnap/],["sat",/^szombat/],["wed",/^szerda/],["fri",/^péntek/],["mon",/^hétfő/],["tue",/^kedd/]]});
Globalize.a778486558 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^szeptember/],["8",/^augusztus/],["11",/^november/],["12",/^december/],["2",/^február/],["3",/^március/],["4",/^április/],["10",/^október/],["1",/^január/],["6",/^június/],["7",/^július/],["5",/^május/]]});
Globalize.b1102805374 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b1784381679 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.a1606439440 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMM d.","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^szept\./],["2",/^febr\./],["3",/^márc\./],["1",/^jan\./],["4",/^ápr\./],["5",/^máj\./],["6",/^jún\./],["7",/^júl\./],["8",/^aug\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./]]});
Globalize.b1759346055 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM d.","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^szeptember/],["8",/^augusztus/],["11",/^november/],["12",/^december/],["2",/^február/],["3",/^március/],["4",/^április/],["10",/^október/],["1",/^január/],["6",/^június/],["7",/^július/],["5",/^május/]]});
Globalize.b943099044 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y. MMMM d.","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^szeptember/],["8",/^augusztus/],["11",/^november/],["12",/^december/],["2",/^február/],["3",/^március/],["4",/^április/],["10",/^október/],["1",/^január/],["6",/^június/],["7",/^július/],["5",/^május/]]});
Globalize.a1909179460 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^szeptember/],["8",/^augusztus/],["11",/^november/],["12",/^december/],["2",/^február/],["3",/^március/],["4",/^április/],["10",/^október/],["1",/^január/],["6",/^június/],["7",/^július/],["5",/^május/]]});
Globalize.a1909864653 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y. MMM d.","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^szept\./],["2",/^febr\./],["3",/^márc\./],["1",/^jan\./],["4",/^ápr\./],["5",/^máj\./],["6",/^jún\./],["7",/^júl\./],["8",/^aug\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./]]});
Globalize.a1252713040 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMM d., EEEE","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^szept\./],["2",/^febr\./],["3",/^márc\./],["1",/^jan\./],["4",/^ápr\./],["5",/^máj\./],["6",/^jún\./],["7",/^júl\./],["8",/^aug\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./]],"gregorian/days/format/wide":[["thu",/^csütörtök/],["sun",/^vasárnap/],["sat",/^szombat/],["wed",/^szerda/],["fri",/^péntek/],["mon",/^hétfő/],["tue",/^kedd/]]});
Globalize.b1766734223 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMM d., E","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^szept\./],["2",/^febr\./],["3",/^márc\./],["1",/^jan\./],["4",/^ápr\./],["5",/^máj\./],["6",/^jún\./],["7",/^júl\./],["8",/^aug\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./]],"gregorian/days/format/abbreviated":[["wed",/^Sze/],["sat",/^Szo/],["thu",/^Cs/],["sun",/^V/],["mon",/^H/],["tue",/^K/],["fri",/^P/]]});
module.exports = Globalize;
